const Skeleton = ({ height = 16, width = '100%', radius = 10 }) => {
    return (
        <div
            className="skeleton"
            style={{ height, width, borderRadius: radius }}
        />
    );
};

export default Skeleton;
